module.exports = __webpack_public_path__ + "img/tosola_app-icon.0604762e.png";